/**
 * src/services/metaSheetsApi.js
 *
 * Fetches Meta Ads data via the local proxy route /api/meta-ads/data.
 * The proxy (in index.ts) handles the Google Apps Script API key server-side.
 * No env vars needed in browser code.
 *
 * Supported endpoints: all | raw_ads | raw_actions | age_gender | device | platform
 */

/**
 * Fetch one endpoint from the local Meta Ads proxy.
 * @param {string} endpoint - "all" | "raw_ads" | "raw_actions" | "age_gender" | "device" | "platform"
 * @returns {Promise<object>} Parsed JSON response
 */
export async function fetchMetaSheetsEndpoint(endpoint = "all") {
  const res = await fetch(`/api/meta-ads/data?endpoint=${encodeURIComponent(endpoint)}`);

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    if (res.status === 503) {
      throw new Error("[metaSheetsApi] META_SHEETS_API_URL not configured on server");
    }
    throw new Error(
      `[metaSheetsApi] HTTP ${res.status} — ${body.error ?? res.statusText}`
    );
  }

  const data = await res.json();

  if (data && data.error) {
    throw new Error(`[metaSheetsApi] API error: ${data.error}`);
  }

  return data;
}

/**
 * Fetch all endpoints in one call (endpoint=all).
 * Returns { raw_ads, raw_actions, age_gender, device, platform }
 */
export async function fetchAllMetaData() {
  return fetchMetaSheetsEndpoint("all");
}
